import React from 'react'

export default function AddPageNumber(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M30.3 8.8V32c0 1.8-1.5 3.2-3.2 3.2H5c-1.8 0-3.2-1.5-3.2-3.2V4C1.8 2.2 3.2.7 5 .7h17.2c.5 0 1.1.2 1.4.6l6.1 6c.3.4.6.9.6 1.5Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M26.13 18.99a.5.5 0 0 1 0 1H5.16a.5.5 0 0 1 0-1h20.97Zm-.05-3.26a.5.5 0 1 1 0 1H5.16a.5.5 0 0 1 0-1h20.92Zm-.07-3.65a.5.5 0 1 1 0 1H15.47a.5.5 0 0 1 0-1h10.54Zm0-3.08a.5.5 0 0 1 0 1H15.47a.5.5 0 0 1 0-1h10.54Z"
        />
        <path
          fill="currentColor"
          d="M30.2 6.8 23.8.6c-.3-.4-.9-.6-1.4-.6h-18C2.6 0 1 1.5 1 3.4v29.2C1 34.5 2.6 36 4.4 36h23.1c1.9 0 3.4-1.5 3.4-3.3V8.5c.1-.7-.2-1.3-.7-1.7Zm-.4 24.9c0 1.7-1.4 3.2-3.1 3.2H5.3c-1.7 0-3.1-1.4-3.1-3.2V4.3c0-1.7 1.4-3.2 3.1-3.2h16.5c.5 0 1 .2 1.4.6l5.9 5.8c.4.4.7 1 .6 1.6v22.6h.1Z"
        />
        <path
          fill="currentColor"
          d="m6.56 5-.254 1.43h1.14L7.702 5h1.141L8.59 6.43h.865L9.26 7.485h-.859l-.184 1.032h.864L8.888 9.57H8.03L7.776 11h-1.14l.254-1.43H5.75L5.496 11H4.354l.255-1.43h-.866l.194-1.053h.857l.184-1.032h-.864l.193-1.055h.858L5.42 5h1.14ZM13 5v6h-1.566V6.353h-.037l-1.452.82V5.92l1.6-.92H13ZM6.12 7.485l-.184 1.032h1.14l.183-1.032H6.12Z"
        />
      </svg>
    </div>
  )
}
